// removed by extract-text-webpack-plugin
module.exports = {"sidebar":"style__sidebar__30NRd","date":"style__date__luSZd","tip":"style__tip__2Gevm","info_container":"style__info_container__2OZaS","info_box":"style__info_box__3TCov","errorNotes":"style__errorNotes__3sEoC","info_row":"style__info_row__1BVk8","info_value":"style__info_value__1kbO7"};


//////////////////
// WEBPACK FOOTER
// ./src/components/account_page/story_details/sidebar/style.scss
// module id = 353
// module chunks = 0